import { Copy } from "lucide-react";
import { toast } from "sonner";

const buildScript = (secret) => `const SECRET = "${secret}";
const HEADERS = ["Ricevuta", "Evento", "Nome", "Cognome", "Telefono", "Anno di nascita", "Lista", "Privacy", "Marketing"];

// Usa il foglio da cui hai aperto lo script; se non c'è, ne crea uno e lo ricorda.
function getBook() {
  const active = SpreadsheetApp.getActiveSpreadsheet();
  if (active) return active;
  const props = PropertiesService.getScriptProperties();
  const id = props.getProperty("SHEET_ID");
  if (id) return SpreadsheetApp.openById(id);
  const book = SpreadsheetApp.create("Prenotazioni Eclipsia");
  props.setProperty("SHEET_ID", book.getId());
  return book;
}

function doPost(e) {
  const p = (e && e.parameter) || {};
  if (p.secret !== SECRET) return ContentService.createTextOutput("unauthorized");
  const sheet = getBook().getSheets()[0];
  if (sheet.getLastRow() === 0) sheet.appendRow(HEADERS);
  sheet.appendRow([
    new Date(), p.eventDate, p.nome, p.cognome, "'" + p.telefono, p.anno, p.lista,
    p.privacyConsent === "true" ? "Sì" : "No",
    p.marketingConsent === "true" ? "Sì" : "No",
  ]);
  return ContentService.createTextOutput("ok");
}

// Apri l'URL /exec nel browser per avere il link al foglio.
function doGet() {
  return HtmlService.createHtmlOutput('<a href="' + getBook().getUrl() + '" target="_blank">Apri il foglio delle prenotazioni</a>');
}`;

const STEPS = [
  "Apri sheets.new e crea un foglio nuovo (dagli un nome, es. Prenotazioni Eclipsia).",
  "Dal menu del foglio: Estensioni → Apps Script. Cancella tutto quello che c'è e incolla il codice qui sotto. Premi il dischetto per salvare.",
  "In alto a destra: Esegui il deployment → Nuovo deployment → ingranaggio → App web.",
  "Esegui come: Me. Chi ha accesso: Chiunque. Premi Esegui il deployment e autorizza con il tuo account Google.",
  "Copia l'URL dell'app web (finisce con /exec), incollalo qui sopra, premi Salva collegamento e poi Prova collegamento.",
  "Se modifichi il codice di uno script già pubblicato: Esegui il deployment → Gestisci deployment → matita → Versione: Nuova versione → Esegui il deployment. L'URL resta lo stesso.",
];

export const SheetGuide = ({ secret }) => {
  const code = buildScript(secret);
  const copy = async () => {
    await navigator.clipboard.writeText(code);
    toast.success("Codice copiato");
  };
  return (
    <details className="group min-w-0" data-testid="admin-sheet-guide">
      <summary className="cursor-pointer text-sm text-white/80 hover:text-white list-none flex items-center justify-between">
        Come collegare un foglio nuovo <span className="text-white/40 group-open:rotate-45 transition-transform text-lg leading-none">+</span>
      </summary>
      <ol className="mt-4 flex flex-col gap-2.5 text-xs text-white/65 leading-relaxed list-decimal pl-4">
        {STEPS.map((s) => <li key={s}>{s}</li>)}
      </ol>
      <div className="relative mt-4">
        <pre className="text-[10.5px] leading-relaxed bg-white/[0.04] border border-white/10 rounded-xl p-4 overflow-x-auto text-white/75 font-mono" data-testid="admin-sheet-script">{code}</pre>
        <button type="button" onClick={copy} data-testid="admin-sheet-copy-script"
          className="absolute top-2 right-2 bg-white text-black rounded-full px-3 py-1.5 text-xs font-medium flex items-center gap-1.5 hover:opacity-90">
          <Copy className="w-3 h-3" /> Copia
        </button>
      </div>
      <p className="mt-3 text-[11px] text-white/40">Se cambi la chiave segreta, ricopia il codice nello script e fai un nuovo deployment.</p>
    </details>
  );
};
